import { useEffect, useState } from 'react';

const useDeviceFingerprint = () => {
    const [id, setId] = useState(null);

    // 1. Captura a assinatura da GPU (Hardware puro)
    const getGPUSignature = (gl) => {
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        return {
            vendor: gl.getParameter(gl.VENDOR),
            renderer: gl.getParameter(gl.RENDERER),
            unmaskedRenderer: debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_ID) : 'N/A',
            shadingLanguageVersion: gl.getParameter(gl.SHADING_LANGUAGE_VERSION),
        };
    };

    // 2. Canvas Normalizado (Imune ao Zoom)
    const getNormalizedCanvas = () => {
        const canvas = document.createElement('canvas');
        // Definimos dimensões fixas. O navegador renderiza internamente 
        // nesses pixels independente do zoom da página.
        canvas.width = 240;
        canvas.height = 60;
        const ctx = canvas.getContext('2d');

        // Teste de renderização complexa (fontes, emojis, sombras)
        ctx.textBaseline = "top";
        ctx.font = "14px 'Arial'";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText("Fingerprint.v2.0", 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText("👽🧬💻", 4, 17);

        return canvas.toDataURL();
    };

    useEffect(() => {
        const generate = async () => {
            const canvas = document.createElement('canvas');
            const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

            const hardwareData = {
                gpu: getGPUSignature(gl),
                cores: navigator.hardwareConcurrency, // Núcleos de CPU
                mem: navigator.deviceMemory, // RAM (estimada)
                platform: navigator.platform, // OS
                // Usamos screen.width/height fixos. 
                // Nota: Mudar resolução do Windows muda isso, mas zoom não.
                screenRes: `${window.screen.width}x${window.screen.height}`,
                canvasSig: getNormalizedCanvas(),
                // Fontes: medimos apenas se elas existem, ignorando o tamanho do zoom
                fonts: ['Arial', 'Verdana', 'Times New Roman', 'Consolas'].filter(f => document.fonts.check(`12px "${f}"`))
            };

            // Gerar Hash SHA-256
            const rawString = JSON.stringify(hardwareData);
            const msgUint8 = new TextEncoder().encode(rawString);
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const finalHash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

            setId(finalHash);
        };

        generate();
    }, []);

    return id;
};

export default useDeviceFingerprint;